module.exports = __webpack_public_path__ + "img/sk.d9939f67.svg";